export default __webpack_public_path__ + "ef6d1d09b20b877fee4ee89fde70755b.woff";